import React from 'react';
import NotificationManagement from './NotificationManagement';

const Notifications = () => {
  return <NotificationManagement />;
};

export default Notifications; 